module.exports = __webpack_public_path__ + "static/img/Z1.b879851b.jpg";